import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";
import { useState } from "react";

import { usePageTitle } from "@/utils/usePageTitle";

import { useGetCompanyRevenuesQuery } from "../../redux/company-revenue/company-revenue.api";
import { companyRevenueSelector } from "../../redux/company-revenue/company-revenue.slice";
import EditableCompanyRevenueList from "./components/EditableCompanyRevenueList";

export default function ManageCompanyRevenue() {
	const { isLoading: isLoadingInitialData } = useGetCompanyRevenuesQuery();
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-company-revenue.${key}`);
	const companyRevenues = useSelector(companyRevenueSelector);
	const [editingCompanyRevenueId, setCompanyRevenueId] = useState(-1);

	usePageTitle(ts("title"));

	return (
		<div className="p-6">
			<EditableCompanyRevenueList
				data={companyRevenues}
				editingCompanyRevenueId={editingCompanyRevenueId}
				isLoading={isLoadingInitialData}
				setEditingCompanyRevenueId={setCompanyRevenueId}
			/>
		</div>
	);
}
